import React from "react";

export const LeftArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    width="30"
    height="26"
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.3137 10.6475L28.3605 10.6577H8.28586L14.5966 4.33309C14.9056 4.02431 15.0751 3.60602 15.0751 3.16699C15.0751 2.72797 14.9056 2.3126 14.5966 2.00309L13.6146 1.02065C13.3059 0.711869 12.8944 0.541138 12.4556 0.541138C12.0166 0.541138 11.6049 0.71065 11.2961 1.01943L0.478299 11.8363C0.168299 12.1463 -0.00121298 12.5592 6.53448e-06 12.9985C-0.00121298 13.4402 0.168299 13.8533 0.478299 14.1628L11.2961 24.9806C11.6049 25.2892 12.0163 25.4589 12.4556 25.4589C12.8944 25.4589 13.3059 25.2889 13.6146 24.9806L14.5966 23.9982C14.9056 23.6899 15.0751 23.2782 15.0751 22.8392C15.0751 22.4004 14.9056 22.0104 14.5966 21.7019L8.21464 15.3419H28.3361C29.2403 15.3419 30 14.5626 30 13.6589V12.2694C30 11.3658 29.2178 10.6475 28.3137 10.6475Z"
      fill="currentColor"
    />
  </svg>
);
